import React from 'react';
import ExpandableFloatingDropdown from '../common/ExpandableFloatingDropdown';

export default class EditPageBase extends React.Component {
    render() {
        return (
            <div className="project-edit-page">
                {this.renderPageTitleBar()}
                {this.renderPageBody()}
            </div>
        )
    }

    renderPageTitleBar() {
        const actionButtons = this.getActionButtons();

        return (
            <div className="page-body-titlebar">
                <h3 className="page-body-title">{this.renderPageTitle()}</h3>
                <div className="page-body-action-buttons">
                    <div className="desktop-only">
                        {actionButtons.map(this.renderDesktopActionButton)}
                    </div>

                    <div className="mobile-only">
                        <ExpandableFloatingDropdown>
                            {actionButtons.map(this.renderMobileActionButton)}
                        </ExpandableFloatingDropdown>
                    </div>
                </div>
            </div>
        )
    }

    renderDesktopActionButton = (button, idx) => {
        if (button.disabled) {
            return <React.Fragment key={idx}></React.Fragment>;
        }

        return <Butotn key={idx} onClick={button.onClick}>{button.label}</Butotn>
    }

    renderMobileActionButton = (button, idx) => {
        if (button.disabled) {
            return <React.Fragment key={idx}></React.Fragment>;
        }

        return <ExpandableFloatingDropdown.Item key={idx}
                                                onClick={button.onClick}>{button.label}</ExpandableFloatingDropdown.Item>;
    }

    renderPageBody() {
        return <React.Fragment></React.Fragment>;
    }

    renderPageTitle() {
        return <React.Fragment></React.Fragment>;
    }

    getActionButtons() {
        return [];
    }
}